import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';
/**
 * Chart.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class Partner extends BaseAPIModel {
    fields() {
        return {
            uuid: { readOnly: true, primaryKey: true },
            name: {},
            visibility: {}
        };
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][Partner] organizationId is mandatory');
        }
        return `/ticket/organizations/${organizationId}/partners`;
    }

    isDeleted() {
        return this.status === 'deleted';
    }

    static async_perform_action_free_bookings({ organization, partnerIds, inventoryIds }) {
        if (partnerIds?.length <= 0) {
            throw new ArgumentError('[Model][Partner] partnerIds is mandatory and should not be empty.');
        }
        const data = {
            type: 'async_free_remaining_bookings',
            resource_query_filter: {
                id__in: partnerIds.join(',')
            }
        };
        if (inventoryIds) {
            data['config'] = { inventory_ids: inventoryIds };
        }
        return this.fetcher.post(`/ticket/organizations/${organization.id}/partners/actions`, { data });
    }

    static perform_action_restore(organization, partner) {
        return this.fetcher.patch(`/ticket/organizations/${organization.id}/partners/${partner.pk}/restore`);
    }
}
